export default __webpack_public_path__ + "static/media/facebook-logo.b24a95a1.svg";